export const EVENT_CONFIRMATION_DEFAULTS = Object.freeze({
  pretitle: "Înscriere înregistrată",
  title: "Pregătim mostrele pentru tine",
  text: "Datele tale au fost transmise",
});

const getTextOrFallback = (value, fallback) => {
  if (typeof value !== "string") return fallback;
  const normalizedValue = value.trim();
  return normalizedValue || fallback;
};

export const resolveEventConfirmationCopy = (event = {}) => ({
  pretitle: getTextOrFallback(
    event.confirmationPretitle,
    EVENT_CONFIRMATION_DEFAULTS.pretitle
  ),
  title: getTextOrFallback(
    event.confirmationTitle,
    EVENT_CONFIRMATION_DEFAULTS.title
  ),
  text: getTextOrFallback(
    event.confirmationText,
    EVENT_CONFIRMATION_DEFAULTS.text
  ),
});
